import React, { useState } from 'react';
import { RemoteAccessDialog } from '~/src/components/RemoteAccessDialog/RemoteAccessDialog';

export const useRemoteAccessDialog = () => {
  const [open, setOpen] = useState(false);
  return [
    () => setOpen(true),
    <RemoteAccessDialog
      key="remote-access-dialog"
      onClose={() => setOpen(false)}
      open={open}
    />,
  ];
};
